<svg 
    [ngClass]="IconClass"
    x="0px"
    y="0px"
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 20 20"
    focusable="false">
    <polygon points="8,5 13,10 8,15"></polygon>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-right-arrow.html